import React from 'react';
import PDFViewer from 'pdf-viewer-reactjs';

const link =
  'https://fh.filgolf.com/files/ele/E_Minutes_of_26_June_2015_Annual_Meeting.pdf';

export default function E() {
  return (
    <>
      <h5 className="is-size-5 mb-4">
        <strong>E. Minutes of 26 June 2015 Annual Meeting</strong>
      </h5>
      <a className="button  is-link" href={link} download>
        DOWNLOAD
      </a>
      <PDFViewer
        document={{
          url: link
        }}
        rotationAngle={0}
        css="customViewer"
      />
    </>
  );
}
